<h1 class="confirmation-message-heading" mat-dialog-title>{{ title }}</h1>
<mat-dialog-content class="mat-dialog-content-no-heading hangup-dialog">
  <div class="confirmation-dialog-message">
    {{ message }}
  </div>
  <div class="active-call-status">
    @if (isLoading) {
      <div class="loading-message">Checking if call is ongoing...</div>
      <mat-spinner diameter="30"></mat-spinner>
    } @else {
      <div class="call-status-message" [class.warning]="isCallActive">{{ callStatusMessage }}</div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="button"
    mat-raised-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="isLoading || isRoutingToEmptyExitRouteAndCallIsNotActive"
    >Yes</button
    >
    <button type="button" mat-stroked-button color="primary" (click)="onCloseClick()">No</button>
  </mat-dialog-actions>
